import { combineReducers } from 'redux';

import systemStatus from './systemStatus/systemStatusReducer';

export default combineReducers({
	systemStatus,
});
